import { z } from 'zod';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
export const streakSavedNoticeSchema = z.object({
    /** How many freezes were spent covering the days the user missed. */
    freezesUsed: z.number(),
    /** Freezes the user has after returning. */
    freezesRemaining: z.number(),
});
export const streakSchema = z.object({
    currentStreak: z.number(),
    freezesRemaining: z.number(),
    /** Present on the day freezes covered days the user missed, until dismissed. */
    savedNotice: streakSavedNoticeSchema.nullable(),
});
export const streakQueryKey = ['streak'];
/**
 * The user's streak. A POST because loading it counts the visit as today's activity; calling
 * it again on the same day, from any device, changes nothing, so refetching is safe.
 */
export const useGetStreak = (authenticatedRequest) => {
    return useQuery({
        queryKey: streakQueryKey,
        queryFn: () => authenticatedRequest({ url: '/streak/check-in', method: 'POST' }, streakSchema),
    });
};
/** Dismisses the "streak saved" notice. Hides it at once, and restores it if the call fails. */
export const useDismissStreakSavedNotice = (authenticatedRequest) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: () => authenticatedRequest({ url: '/streak/saved-notice', method: 'DELETE' }, z.any()),
        onMutate: async () => {
            await queryClient.cancelQueries({ queryKey: streakQueryKey });
            const previous = queryClient.getQueryData(streakQueryKey);
            queryClient.setQueryData(streakQueryKey, (current) => current?.data ? { ...current, data: { ...current.data, savedNotice: null } } : current);
            return { previous };
        },
        onError: (_error, _variables, context) => {
            if (context?.previous) {
                queryClient.setQueryData(streakQueryKey, context.previous);
            }
        },
    });
};
